import React, { useEffect, useState } from "react";
import { DragDropContext, Droppable, Draggable } from "react-beautiful-dnd";
import Layout from "../../components/layout";
import "./CategoryOrder.css";

const CategoryOrder = () => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchCategories = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/categories/order`);
      const data = await response.json();
      setCategories(data);
    } catch (error) {
      console.error("Error fetching categories:", error);
    }
  };

  const handleDragEnd = async (result) => {
    if (!result.destination) return;

    const reorderedCategories = Array.from(categories);
    const [moved] = reorderedCategories.splice(result.source.index, 1);
    reorderedCategories.splice(result.destination.index, 0, moved);

    updateCategoryOrder(reorderedCategories);
  };

  const updateCategoryOrder = async (reorderedCategories) => {
    const updatedPositions = reorderedCategories.map((category, index) => ({
      category: category.category,
      position: index + 1,
    }));

    setCategories(reorderedCategories);

    try {
      await fetch(`${process.env.REACT_APP_API_URL}/api/categories/reorder`, {
        method: "PUT",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ reorderedCategories: updatedPositions }),
      });
    } catch (error) {
      console.error("Error updating category positions:", error);
    }
  };

  const moveCategory = (index, direction) => {
    const newCategories = [...categories];
    const [movedItem] = newCategories.splice(index, 1);
    newCategories.splice(index + direction, 0, movedItem);
    updateCategoryOrder(newCategories);
  };

  return (
    <Layout>
      <DragDropContext onDragEnd={handleDragEnd}>
        <Droppable droppableId="categories">
          {(provided) => (
            <div className="categories-container" {...provided.droppableProps} ref={provided.innerRef}>
              {categories.map((category, index) => (
                <Draggable key={category.category} draggableId={category.category} index={index}>
                  {(provided, snapshot) => (
                    <div
                      ref={provided.innerRef}
                      {...provided.draggableProps}
                      {...provided.dragHandleProps}
                      className={`category-card ${snapshot.isDragging ? "dragging" : ""}`}
                    >
                      <span className="category-title">{category.category}</span>
                      <div className="reorder-buttons">
                        <button
                          onClick={() => moveCategory(index, -1)}
                          disabled={index === 0}
                        >
                          ↑
                        </button>
                        <button
                          onClick={() => moveCategory(index, 1)}
                          disabled={index === categories.length - 1}
                        >
                          ↓
                        </button>
                      </div>
                    </div>
                  )}
                </Draggable>
              ))}
              {provided.placeholder}
            </div>
          )}
        </Droppable>
      </DragDropContext>
    </Layout>
  );
};

export default CategoryOrder;
